import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		width: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 300px;
		}
	`,
	SelectWrapper: styled.div`
		position: relative;
		display: flex;
		width: 100%;
		height: 40px;
		background-color: ${({theme}) => theme.color.grey1};

		& > select {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 10px 8px;
			padding-right: 28px;
			appearance: none;
			-webkit-appearance: none;
			-moz-appearance: none;
			cursor: pointer;
		}

		img {
			position: absolute;
			right: 8px;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			width: 12px;
			height: 12px;
		}
	`,
	GiveDiv: styled.div`
		display: flex;
		gap: 8px;
		width: 100%;
		height: 40px;

		& > input {
			${({theme}) => theme.font.extra_small};
			flex: 1;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 10px 8px;
		}
	`,
}
export default Style
